import { IShouldShowDeliveryMessage } from './types';

export const shouldShowDeliveryMessage = ({
  offers,
  loading,
  isDelivery,
}: IShouldShowDeliveryMessage) => offers.length === 0 && !loading && isDelivery;
